angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("join-zoom-meeting-cta-template.html", "<label>&nbsp;</label> <div class=\"text-center\"> <div class=\"btn btn-success\" ng-click=\"showModal()\">Join Bridge to your Zoom Meeting Now!</div> <div class=\"label label-danger pull-right\">New!</div> <p class=\"text-muted\"> Connect your bridge live to your Zoom meeting, getting everyone in the same meeting, with your branding. </p> </div> <join-zoom-meeting-modal is-visible=\"d.modal\" ng-if=\"d.modal\" bridge=\"bridge\"></join-zoom-meeting-modal>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/join-zoom/join-zoom-meeting-cta/join-zoom-meeting-cta-template.html
 ** module id = 336
 ** module chunks = 0
 **/